<template>

  <modalo
    :title="candidate.name"
    type="mini"
    @hideModal="hideModal()"
    :modaloWatch="() => candidate">

    <form id="candidate-form" v-on:submit.prevent="createCandidate(candidate)">

      <div class="mb-4">
        <label><strong>Adicionar à vaga</strong></label>
        <select-job 
          v-model="candidate.job_id"
          :filters="{status: 'open'}">
          </select-job>
      </div>

      <hr>

      <div class="form-group">
        <input-media 
          v-model="candidate.resume_media_id"
          :multiple="false">
          Selecionar currículo
          </input-media>
      </div>

      <div class="form-group">
        <input v-autofocus class="form-control" type="text" :placeholder="`${ $t('Name') } *`" v-model="candidate.name">
        <ValidateMessage :error="validateErrors.name" />
      </div>

      <div class="form-group">
        <input class="form-control" type="text" :placeholder="$t('Headline')" v-model="candidate.headline">
        <ValidateMessage :error="validateErrors.headline" />
      </div>

      <div class="form-group">
        <input class="form-control" type="text" :placeholder="$t('Phone')" v-model="candidate.phones[0]">
        <ValidateMessage :error="validateErrors['phones.0']" />
      </div>

      <div class="form-group">
        <input class="form-control" type="text" :placeholder="$t('Email')" v-model="candidate.email">
        <ValidateMessage :error="validateErrors.email" />
      </div>

      <div class="form-group">
        <select-source
          v-model="candidate.source_id"
          :placeholder="$t('Source')">
          </select-source>
        <ValidateMessage :error="validateErrors.source_id" />
      </div>

      <div class="card">
        <div class="card-header">
          {{ $t('Qualifications summary') }}
        </div>
        <textarea-autosize
          v-model="candidate.summary"
          :min-height="160"
          class="form-control">
          </textarea-autosize>
        <ValidateMessage :error="validateErrors.summary" />
      </div>
      
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="candidate-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click.stop="hideModal()">{{ $t('Cancel') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
import SelectJob from '@/components/Fields/SelectJob'
import SelectSource from '@/components/Fields/SelectSource'
import InputMedia from '@/components/Fields/InputMedia'

export default {
  name: 'CandidateCreateForm',
  components: {
    SelectJob,
    SelectSource,
    InputMedia
  },
  props: [
    'initCandidate'
  ],
  data () {
    return {
      loading: false,
      candidate: this.defaultValues(this.initCandidate),
      validateErrors: {}
    }
  },
  started () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return Object.assign({
        phones: []
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    createCandidate
    */
    createCandidate (data) {
      this.loading = true

      data.phones = data.phones.filter(v => v.trim())
      data.summary = data.summary || null

      this.$store.dispatch('createCandidate', data)
      .then((response) => {
        this.loading = false
        this.$emit('saved', response)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CandidateCreateForm/CandidateCreateForm.vue